import { useState } from "react";
import { ReviewCard } from "./ReviewCard";
import { supabase } from "../../../../../integrations/supabase/client";
import { useToast } from "../../../../../hooks/use-toast";

interface WallOfLoveGalleryProps {
  reviews: any[];
  onUpdate: () => void;
}

export const WallOfLoveGallery = ({ reviews, onUpdate }: WallOfLoveGalleryProps) => {
  const { toast } = useToast();
  const [updatingId, setUpdatingId] = useState<string | null>(null);

  const handleToggleFeatured = async (id: string, currentStatus: boolean) => {
    setUpdatingId(id);
    try {
      const { error } = await supabase
        .from("reviews")
        .update({ is_featured: !currentStatus })
        .eq("id", id);

      if (error) throw error;

      toast({
        title: currentStatus ? "Removed from Wall" : "Added to Wall",
        description: currentStatus
          ? "Review has been removed from Wall of Love"
          : "Review is now featured on Wall of Love",
      });

      onUpdate();
    } catch (error) {
      console.error("Error toggling featured:", error);
      toast({
        title: "Error",
        description: "Failed to update review",
        variant: "destructive",
      });
    } finally {
      setUpdatingId(null);
    }
  };

  if (reviews.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        No reviews found. Reviews with 4-5 stars and positive sentiment will appear here.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {reviews.map((review) => (
        <ReviewCard
          key={review.id}
          review={review}
          onToggleFeatured={handleToggleFeatured}
          isUpdating={updatingId === review.id}
        />
      ))}
    </div>
  );
};
